var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFerme1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #572e1c;\n      }\n\n      .cls-2 {\n        fill: #bf846a;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.24,
    y: -0.94,
    width: 60.49,
    height: 59.89
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "row2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "padlocks-6",
    className: "cls-1",
    d: "M37.82,26.71v-4.54c0-2.36-.92-4.57-2.6-6.25-1.68-1.68-3.89-2.6-6.25-2.6-4.88,0-8.85,3.96-8.85,8.85v4.54h-2.38v7.9c0,5.39,4.4,9.82,9.82,9.82h2.87c5.39,0,9.82-4.4,9.82-9.82v-7.9h-2.43ZM21.33,21.84c.07-3.95,3.69-7.24,7.85-7.24,3.81,0,7.49,3.42,7.43,7.11l.02,5h-15.28l-.02-4.87ZM39,34.59c0,4.71-3.85,8.56-8.56,8.56h-2.93c-4.71,0-8.56-3.85-8.56-8.56l.03-6.69h20.02l-.03,6.69h.02ZM30.75,33.83c0,.68-.39,1.29-.97,1.58v3.35h-1.6v-3.33c-.58-.29-.97-.9-.97-1.58,0-.97.8-1.77,1.77-1.77s1.77.78,1.77,1.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerme1);
export default __webpack_public_path__ + "static/media/Ferme (1).d9e9b17c39dbf4af06df8104a5d28399.svg";
export { ForwardRef as ReactComponent };